import { requestTimeout, handleResponse } from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem(accessToken),
})

const buildQuery = (filters = {}) => {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value)
    })
    const qs = params.toString()
    return qs ? `?${qs}` : ''
}

export const billerNetworkAccountApi = {
    _get: _getBillerNetworkAccounts,
    _create: _createBillerNetworkAccount,
    _update: _updateBillerNetworkAccount,
    _delete: _deleteBillerNetworkAccount,
}

async function _getBillerNetworkAccounts(filters = {}) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `billerNetworkAccounts${buildQuery(filters)}`, {
        method: 'GET',
        headers: authHeaders(),
    })).then(handleResponse)
}

async function _createBillerNetworkAccount(data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `billerNetworkAccounts`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _updateBillerNetworkAccount(id, data) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `billerNetworkAccounts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify(data),
    })).then(handleResponse)
}

async function _deleteBillerNetworkAccount(id) {
    return requestTimeout(apiMaxTime, fetch(apiUrl + `billerNetworkAccounts/${id}`, {
        method: 'DELETE',
        headers: authHeaders(),
    })).then(handleResponse)
}
